import { gql } from '@apollo/client';

export const GET_AGENCY_PROFILE_RATING = gql`
  query GetAgencyProfileRating($agencyId: Int!) {
    agency(agencyId: $agencyId) {
      id
      depthTier
      recommendations {
        overallStarRating
        numberOfReviews
      }
    }
  }
`;

export default GET_AGENCY_PROFILE_RATING;
